import { render, staticRenderFns } from "./OurCommunity.vue?vue&type=template&id=c74154cc&lang=pug&"
import script from "./OurCommunity.vue?vue&type=script&lang=js&"
export * from "./OurCommunity.vue?vue&type=script&lang=js&"
import style0 from "./OurCommunity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports